module.exports = __webpack_public_path__ + "img/121.5a114390.webp";